{
  "navigation-back-button": {
    "text": {
      "back": "Retour",
      "home-page": "Page d'accueil"
    }
  }
}
